const HeroSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
 <section>
      <div className="card text-white border-0 hero-card ">
        {/* Responsive image wrapper with fixed height */}
        <div className="card-img-wrapper">
          <img src={`${awsImageBaseUrl}images/clients/CadillacEscaladeHeroImg.jpg`}  className="card-img rounded-0" alt="Hero Background" />
        </div>
        {/* Overlay Content */}
        <div className="card-img-overlay mt-5 text-center hero-overlay pt-5">
        <h2 className="text-2xl mb-3 text-shadow mt-5 text-shadow">
        General Motors
          </h2>
          <h1 className="font-bold display-5 mb-4 text-shadow red-bottom-border">
          <span className="red-bottom-border">Cadillac Escalade</span>
          </h1>
        </div>

  </div>  
  </section>
  );
};

export default HeroSection;
